import { fetchSOStart, fetchSOSuccess, fetchSOFailure } from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { GET_ALL_SO } from "../../constants/constants";

export const getAllSO =
  (first = 0, offset = 10, status, setLoading) =>
  async (dispatch) => {
    try {
      setLoading(true);

      dispatch(fetchSOStart());

      const response = await determineBaseUrlAndPerformApiCall(
        GET_ALL_SO(first, offset, status),
        "GET",
      );

      dispatch(fetchSOSuccess(response));

      setLoading(false);
    } catch (error) {
      setLoading(false);

      dispatch(fetchSOFailure(error.message));
    }
  };
